module.exports = __webpack_public_path__ + "img/map-2-f-food.a4bf64f8.png";